function GoogleMap(el, options) {
    this.mapElement = el;
    this.lat = MP_LATITUDE;
    this.lng = MP_LONGITUDE;
    this.zoom = MAP_ZOOM;
    this.interactive = true;

    if (options) {
        this.lat = options.lat || this.lat;
        this.lng = options.lng ||this.lng;
        this.zoom = options.zoom || this.zoom;
        this.interactive = options.interactive;
    }

    this.map = null;
    this.latlng = null;
    this.infoWindow = null;
    this.markerList = [];
}

GoogleMap.prototype.getMap = function() {
    return this.map;
};

GoogleMap.prototype.getMarkers = function() {
    return this.markerList;
};

GoogleMap.prototype.setLatLng = function(lat, lng) {
    this.latlng = new google.maps.LatLng(lat, lng);
};

GoogleMap.prototype.setZoom = function(z) {
    this.zoom = parseInt(z);
};

GoogleMap.prototype.clearMap = function() {
    var markerTmp;

    while (this.markerList.length > 0) {
        markerTmp = this.markerList.pop();
        markerTmp.setMap(null);
    }
};

GoogleMap.prototype.setInfoContent = function(info) {
    var content;

    content = '<div class="map-info-window" id="infoWindowPoint"><div class="map-info-window__header"><img src="'+info.icon+'" width="'+info.iconWidth+'" height="'+info.iconHeight+'"/><span class="map-info-window__header-title">';
    content += info.data.name+'</span></div>';
    content += '<div class="map-info-window__content">';
    content += (info.data.address) ? '<p>'+info.data.address+'</p>' : '';
    content += (info.data.zipCode) ? '<p>'+info.data.zipCode+' - '+info.data.location+' ('+info.data.province+')</p>' : '<p>'+info.data.location+' ('+info.data.province+')</p>';
    content += (info.data.fax) ? '<p>'+info.data.phone+' / '+info.data.fax+'</p>' : '';
    content += (info.data.phone) ? '<p>'+info.data.phone+'</p>' : '';
    content += (info.data.email) ? '<p><a href="mailto:'+info.data.email+'">'+info.data.email+'</a></p>' : '';

    if (info.data.address) {
        content += '<p class="map-info-window__howto"><a href="http://maps.google.es/maps?f=d&source=s_d&saddr=&daddr='+escape(info.data.address)+', '+escape(info.zipCode)+', '+escape(info.location)+','+escape(info.province)+'&hl=es&sll'+info.lat+','+info.lng+'=ie=UTF8&ll='+info.lat+','+info.lng+'" target="_blank">'+GOOGLE_HOWTOGO+'</a></p>';
    } else {
        content += '<p class="map-info-window__howto"><a href="http://maps.google.es/maps?f=d&source=s_d&hl=es&sll'+info.lat+','+info.lng+'=ie=UTF8&ll='+info.lat+','+info.lng+'" target="_blank">'+GOOGLE_HOWTOGO+'</a></p>';
    }

    content += '</div></div>';

    return content;
};

GoogleMap.prototype.setInfoMarker = function(marker) {
    var _this = this;

    this.infoWindow = new google.maps.InfoWindow();
    this.infoWindow.setContent(this.setInfoContent(marker.info));
    this.infoWindow.setPosition(marker.getPosition());
    this.infoWindow.set('isdomready', false);
    this.infoWindow.open(this.map);

    google.maps.event.addListener(this.infoWindow, 'domready', function () {
        if (!_this.infoWindow.get('isdomready')) {
            return;
        }

        google.maps.event.trigger(_this.infoWindow, 'content_changed');
        document.querySelector('#infoWindowPoint').parentNode.style.overflow = 'hidden';
        _this.infoWindow.set('isdomready', true);
    });

    google.maps.event.addListener(marker, 'click', function() {
        _this.infoWindow.open(_this.map, marker);
        document.querySelector('#infoWindowPoint').parentNode.style.overflow = 'hidden';
    });
};

GoogleMap.prototype.showMarker = function(marker) {
    var myLatLng;

    if (!marker && this.markerList.length > 0) {
        marker = this.markerList[0];
    }

    myLatLng = new google.maps.LatLng(marker.info.lat, marker.info.lng);

    this.map.panTo(myLatLng);
    this.map.setZoom(parseInt(marker.info.zoom));
    this.setInfoMarker(marker);
};

GoogleMap.prototype.addMarker = function(point) {
    var _this = this;

    var marker,
        latlng,
        icon;

    latlng = new google.maps.LatLng(point.lat, point.lng);

    icon = new google.maps.MarkerImage(
            point.icon,
            new google.maps.Size(point.iconWidth, point.iconHeight),
            new google.maps.Point(0, 0),
            new google.maps.Point(point.iconCenterX, point.iconCenterY)
    );

    marker = new google.maps.Marker({
        position: latlng,
        icon: icon,
        map: this.map,
        clickable: this.interactive,
        info: point
    });

    if (this.interactive && point.data.name) {
        google.maps.event.addListener(marker, 'click', function(ev) {
            _this.showMarker(marker);
        });
    }

    this.markerList.push(marker);
};

GoogleMap.prototype.initMarkers = function(pointList) {
    var nPoints = pointList.length;
    var pointTmp;

    for (i=0; i<nPoints; i++) {
        pointTmp = pointList[i];
        pointTmp.index = i;
        this.addMarker(pointTmp);
    }
};

GoogleMap.prototype.init = function() {
    this.setLatLng(this.lat, this.lng);
    this.setZoom(this.zoom);

    this.map = new google.maps.Map(this.mapElement, {
        center: this.latlng,
        zoom: this.zoom,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    });

    this.clearMap();
};
